export default "__VITE_ASSET__c22b95b7__"